import { useEffect, useMemo, useState } from "react";
import { subscribeToUserNotifications } from "@/features/notifications/notificationService";
import type { UserNotification } from "@/features/notifications/types";

export function useNotifications(uid?: string | null) {
  const [notifications, setNotifications] = useState<UserNotification[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!uid) {
      return undefined;
    }

    void Promise.resolve().then(() => {
      setLoading(true);
      setError(null);
    });

    return subscribeToUserNotifications(
      uid,
      (nextNotifications) => {
        setNotifications(nextNotifications);
        setLoading(false);
      },
      (notificationError) => {
        setError(notificationError.message);
        setNotifications([]);
        setLoading(false);
      }
    );
  }, [uid]);

  const unreadCount = useMemo(
    () =>
      uid
        ? notifications.filter((notification) => notification.status === "unread").length
        : 0,
    [notifications, uid]
  );

  return {
    notifications: uid ? notifications : [],
    unreadCount,
    loading: uid ? loading : false,
    error: uid ? error : null
  };
}
